// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zuSpY{display:flex;flex-direction:column;gap:24px;width:600px}.fd_IN{display:flex;flex-direction:column;gap:24px}.I_tfT{max-width:400px}.JZEUL{display:flex;align-items:center;gap:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `zuSpY`,
	"content": `fd_IN`,
	"field": `I_tfT`,
	"emailContainer": `JZEUL`
};
export default ___CSS_LOADER_EXPORT___;
